/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import AlpsPanel from './layout';

import {
  sidePanelHeader,
  isInherited,
  userHasUpdatePermission,
  userHasDisablePermission,
  userHasPermissions,
  isEntityFetching,
  itemApiPending,
  dataRetentionCreatedHeader
} from '../../../redux/modules/entities/selectors';


import { setSelectedSubEntityId,toggleEntity} from '../../../redux/modules/entities';
import { selectAlpsVersions,isToggleEnabled,isToggleDisabled, selectAlpsHistory,  getSelectableVersionList,
} from '../../../redux/modules/entities/alps/selectors';
import { setTermsForm,setAlpsSelectedSubEntityId } from '../../../redux/modules/entities/alps/actions';

export function mapStateToProps(state) {
  return {
    userHasUpdatePermission: userHasUpdatePermission(state),
    userHasViewPermission: userHasPermissions(state, ['PLATFORM_VIEW_ALL']),
    alpFetching: isEntityFetching(state, 'alps'),
    versionsItems: selectAlpsVersions(state),
    historyItems: selectAlpsHistory(state),
    itemApiPending: itemApiPending(state),
    title: sidePanelHeader(state).title,
    inherited: isInherited(state),
    toggleStatus: isToggleEnabled(state),
    toggleDisable: isToggleDisabled(isToggleEnabled(state),userHasUpdatePermission(state),userHasDisablePermission(state)),
    createdAt: dataRetentionCreatedHeader(state).createdAt,
    updatedAt:  dataRetentionCreatedHeader(state).updatedAt,
    selectableVersions: getSelectableVersionList(state),

  };
}

export const actions = {
  setSelectedSubEntityId,
  setAlpsSelectedSubEntityId,
  toggleEntity,
  setTermsForm,
  onCancel: () => setSelectedSubEntityId(undefined)
};

export default connect(mapStateToProps, actions)(AlpsPanel);

